import $ from 'jquery';
import LocaleSelector from './locale-selector';
import BackToTop from './back-to-top';
import MCTabs from './mc-tabs';
import TextSelection from './text-selection';
import CopyToClipboard from './copy-to-clipboard';
import MCGallery from './mc-gallery';
import MCConsistentFocus from './mc-consistent-focus';
import BrightcovePlayer from './brightcove-player';
import MCAccordion from './mc-accordion';
import MCDropdown from './mc-dropdown';
import MCDatepickerGroup from './datepicker-group';
import PromptInstallAndroid from './prompt-install-android';
import StickySubHeader from '../players/sticky-sub-header';
import Countdown from './countdown';
import CounterMap from './counter-map';
import CityTvVideo from './citytvvideo';
import LimitedMultipleChoice from './limited-multiple-choice';
import MultyMDC from './multy-mdc';

const modules = [
  new MCConsistentFocus(),
  new LocaleSelector({
    localeSelectorSelector: '.js-locale-selector',
    localeModalSelector: '.js-locale-selector-modal',
    closeLocaleModalSelector: '.js-close-locale-modal',
  }),
  new MCTabs(),
  new MCGallery(),
  new TextSelection(),
  new CopyToClipboard(),
  new BrightcovePlayer(),
  new CityTvVideo('.cityTVVideo'),
  new BackToTop('.js-back-to-top'),
  new MCAccordion({
    listSelector: '.js-accordion-list',
    accordionSelector: '.js-accordion',
    btnSelector: '.js-accordion-btn',
  }),
  new MCDropdown({
    dropdownSelector: '.js-dropdown',
    btnSelector: '.js-dropdown-btn',
    listSelector: '.js-dropdown-list',
    btnTextSelector: '.js-dropdown-text',
    selectSelector: '.js-dropdown-select',
  }),
  new MCDatepickerGroup('.datepickerfield'),
  new PromptInstallAndroid(),
  new StickySubHeader('.sticky-sub-header', '.js-main-header'),
  new Countdown(),
  new LimitedMultipleChoice(),
  new CounterMap(),
  $('.js-multy-mdc').length && new MultyMDC(),
];

$(() => {
  const loadCardSliderModule = async () => {
    try {
      const { default: CardSlider } = await import('./card-slider');

      $('.js-card-slider')
        .toArray()
        .map((sliderEl) => new CardSlider({ sliderEl }));
    } catch (error) {
      console.error(`An error was occured during initialization CardSlider: ${error}`);
    }
  };

  if ($('.js-card-slider').length) {
    loadCardSliderModule();
  }
});

export default modules;
